import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnJE: CultureInfo = {
  name: 'en-JE',
  displayName: 'English (Jersey)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-JE',
  parent: CultureInfoEn
};
